import './../../styles/templates/wishlist.scss';
import checkKabiaStock from '../components/kabia-stock.js';

(function (window, $) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const wishlistRender = function (products) {
    $(function () {
      var template = $('[data-wishlist-template]');
      var empty_template = $('[data-wishlist-empty]');
      var $wishlistContainer = $('#wishlist-content');

      var startLoading = function ($context) {
        if ($context) {
          $context.addClass('loading');
        } else {
          $wishlistContainer.addClass('loading');
        }
      }

      var stopLoading = function ($context) {
        if ($context) {
          $context.removeClass('loading');
        } else {
          $wishlistContainer.removeClass('loading');
        }
      }

      if (!products || products.length < 1) {
        empty_template.show();
        return;
      }

      products.forEach(function (p) {
        var row = template.clone();

        row.removeClass('hidden');
        row.find('[data-name]').html(p.dt);
        row.find('[data-vendor]').html(p.bt);
        row.find('[data-url]').attr('href', p.du);
        row.find('[data-image]').attr('src', p.iu);
        row.find('[data-price]').html(p.pr + _swat.currency);
        if (p.op && p.op > p.pr) {
          var percentage = Math.round((p.pr * 100 / p.op), 2);
          row.find('[data-percentage-value]').html(percentage);
          row.find('[data-original-price]').html(p.op + _swat.currency);
        } else {
          row.find('[data-percentage-wrapper]').addClass('hidden');
          row.find('[data-original-price]').addClass('hidden');
        }

        row.find('[data-remove]').on('click', function (e) {
          e.preventDefault();
          startLoading(row);

          _swat.removeFromWishList(p, function callback() {
            row.remove();
            window.loadWishlistBubble(0);
            stopLoading(row);
          });
        });

        const $addToCart = row.find("[data-add-to-cart]");
        if (p.du && $addToCart.length > 0) {
          $addToCart.on("click", async () => {
            startLoading(row);
            try {
              const productUrl = new URL(p.du, window.location.origin);
              if (!productUrl.pathname.includes('/products/')) {
                throw new Error('Impossibile verificare la disponibilità del prodotto.');
              }
              const productResponse = await fetch(productUrl.pathname + productUrl.search);
              if (!productResponse.ok) throw new Error('Impossibile verificare la disponibilità del prodotto.');
              const productPage = new DOMParser().parseFromString(await productResponse.text(), 'text/html');
              const productForm = productPage.querySelector('[data-product-form]');
              const variant = productForm && productForm.querySelector(`select[name="id"] option[value="${Number(p.epi)}"]`);
              if (!productForm || !variant) {
                throw new Error('Impossibile verificare la disponibilità della variante.');
              }
              await checkKabiaStock({
                kabiaId: productForm.dataset.kabiaId,
                size: variant.dataset.kabiaSize,
                quantity: 1,
                variantId: p.epi,
              });

              const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  items: [
                    {
                      id: p.epi,
                      quantity: 1,
                    },
                  ],
                }),
              });
              if (!res.ok) {
                const data = await res.json();
                throw new Error(data.description || data.message || 'Impossibile aggiungere al carrello.');
              }
              if (typeof ShopifyAPI !== 'undefined' && typeof ShopifyAPI.openMinicart !== 'undefined') {
                ShopifyAPI.openMinicart();
              }
              _swat.removeFromWishList(p, function callback() {
                row.remove();
                window.loadWishlistBubble(0);
              });
            } catch (error) {
              row.find('[data-errors]').text(error.message);
            } finally {
              stopLoading(row);
            }
          });
        }

        row.attr('data-link-proxy', p.du);
        row.ProxyLink({ excludes: [".wishlist-page__products-list__actions"] });
        $wishlistContainer.append(row);
      });
    });
  }

  window.SwymCallbacks.push(function () {
    _swat.fetchWrtEventTypeET(function (products) {
      wishlistRender(products);
    }, _swat.EventTypes.addToWishlist);
  });
})(window, jQuery);
